import * as momentImported from 'moment';

const moment = momentImported;

export const getDays = (startDate: Date, endDate: Date): Date[] => {
  const days: Date[] = [];
  while (startDate <= endDate) {
    days.push(startDate);
    startDate = moment(startDate)
      .clone()
      .add(1, 'd')
      .toDate();
  }
  return days;
};
